<template>

   <div class="display-contents">
      <vue-tel-input
         :mode="mode"
         :validCharactersOnly="validCharactersOnly"
         :dropdownOptions="dropdownOptions"
         :inputOptions="inputOptions"
         :autoDefaultCountry="autoDefaultCountry"
         defaultCountry="US"
         v-bind="$attrs"
         v-model="phone"
         @validate="isPhoneValid($event)"
         :preferredCountries="['US', 'GB']"
         :styleClasses='customClass'

      >

      </vue-tel-input>
      <span v-if="!validation.isPhoneValid" class="error">Phone number is invalid</span>

   </div>
</template>

<script>

   const VueTelInput = () =>
      Promise.all([
         import(/* webpackChunkName: "chunk-vue-tel-input" */ 'vue-tel-input'),
         import(/* webpackChunkName: "chunk-vue-tel-input" */ 'vue-tel-input/dist/vue-tel-input.css'),
      ]).then(([{VueTelInput}]) => VueTelInput);

   export default {
      name: "Telephone",

      inheritAttrs: false,

      components: {
         VueTelInput
      },

      props: {
         value: {
            type: [String, Number],
         },

         mode: {
            type: String,
            default: 'international' //national
         },

         autoFormat: {
            type: Boolean,
            default: true,
         },
         autoDefaultCountry: {
            type: Boolean,
            default: false,
         },
         validCharactersOnly: {
            type: Boolean,
            default: false,
         },

         dropdownOptions: {
            type: Object,
            default: () => {
               return {
                  showDialCodeInList: true,
                  showSearchBox: true,
                  showDialCodeInSelection: true,
                  showFlags: true,
                  width: '250px',
               }
            }
         },
         inputOptions: {
            type: Object,
            default: () => {
               return {
                  autocomplete: 'on',
                  id: 'ifix-phone-number',
                  name: 'ifix-phone-number',

               }
            }
         },
         customClass:{
            type: String,
            default: 'form-control px-3 py-1',
         }

      },

      watch: {
         value: {
            handler(newValue, oldValue) {
                  this.phone = newValue ?? "";

            },
            immediate: true,
         },

         phone: {
            handler(newValue, oldValue) {
               this.$emit('input', newValue)
            }
         },
      },

      data() {
         return {
            phone: this.value,

            validation: {
               isPhoneValid: true,
            },
         }
      },

   

      methods: {
         isPhoneValid(phone) {
          
            if (this.phone) {
               this.validation.isPhoneValid = phone.valid;
            }
            this.$emit('validate', phone)
         },

         checkPhoneNumber(){
               return this.validation.isPhoneValid; 
         }
      },

   }
</script>
